import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { inventoryService } from "./inventory.services";
import { CheckInventoryParams, InventoryHistoryEntry } from "./inventory.types";

export * from "./inventory.mutations";
export * from "./inventory.queries";
export * from "./inventory.services";
export * from "./inventory.types";
export * from "./keys";

export function useCheckInventory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CheckInventoryParams) =>
      inventoryService.checkInventory(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inventories"] });
    },
  });
}

export function useBulkCheckInventory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      inventoryIds,
      isChecked,
      serviceTicketId,
    }: {
      inventoryIds: string[];
      isChecked: boolean;
      serviceTicketId?: string;
    }) =>
      inventoryService.bulkCheckInventory(
        inventoryIds,
        isChecked,
        serviceTicketId
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inventories"] });
    },
  });
}

export function useInventoryHistory(inventoryId: string, enabled = true) {
  return useQuery<InventoryHistoryEntry[]>({
    queryKey: ["inventory-history", inventoryId],
    queryFn: () => inventoryService.getInventoryHistory(inventoryId),
    enabled,
  });
}
